import React, {useEffect, useState} from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './sidebar/Sidebar';
import CreateLeadModal from "../modals/CreateLeadModal";
import DueCollectionReminderModal from "../modals/DueCollectionReminderModal";
import OverdueCollectionReminderModal from "../modals/OverdueCollectionReminderModal";
import { Modal } from 'bootstrap';

const Layout = () => {
    const location = useLocation();
    const path = location.pathname

    console.log('Current path:', path);

    const [isSidebarClose, setIsSidebarClose] = useState(false);
    const handleSidebarToogle = () =>  setIsSidebarClose(!isSidebarClose);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleSidebarOpen = ()=> setIsSidebarOpen(!isSidebarOpen);

    useEffect(() => {
        const modals = document.querySelectorAll('.modal');
        modals.forEach(modalElement => {
            new Modal(modalElement);
        });
    }, []);

    return (
            <div className='layout-1'   >
                <Sidebar isSidebarClose={isSidebarClose} isSidebarOpen={isSidebarOpen}  />
                <div className="wrapper">
                    <Header isSidebarClose={isSidebarClose} isSidebarOpen={isSidebarOpen} handleSidebarToogle={handleSidebarToogle} handleSidebarOpen={handleSidebarOpen}  />
                    <Outlet />
                    {/*<Footer />*/}
                </div>

                {/* Create Lead Modal  ABBC*/}
                <div className="modal modal-slide-in-left fade" id="CreateLead" tabIndex={-1} aria-labelledby="createLeadLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-vertical" style={{ maxWidth: '900px', width: '90%' }}>
                        <CreateLeadModal />
                    </div>
                </div>

                {/* Due Collection Reminder Modal */}
                <div className="modal modal-slide-in-left fade" id="DueCollectionReminder" tabIndex={-1} aria-labelledby="dueCollectionReminderLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-vertical modal-dialog-scrollable">
                        <DueCollectionReminderModal />
                    </div>
                </div>

                {/* Overdue Collection Reminder Modal AA */}
                <div className="modal modal-slide-in-left fade" id="OverdueCollectionReminder" tabIndex={-1} aria-labelledby="overdueCollectionReminderLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-vertical modal-dialog-scrollable">
                        <OverdueCollectionReminderModal />
                    </div>
                </div>
            </div>
    );
};

export default Layout;
